<template>
    <div class="top-container">
        <!-- 成长明细-->
        <el-scrollbar class="second-container" v-if="activeItem==='1'" >
            <div class="detail-card">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 214px)"
                          :data="detailList"
                          highlight-current-row>
                    <el-table-column align="center" label="类型" prop="typeName" />
                    <el-table-column align="center" label="业务" prop="businessName" />
                    <el-table-column align="center" label="课时" prop="amount">
                        <template #default="scope">
                            <span class="amount-text">{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center">
                        <template #default="scope">
                            <el-button type="primary"  size="small" @click="viewDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-scrollbar>
        <!-- 师资培训-->
        <el-scrollbar class="second-container" v-if="activeItem==='2'" >
            <div class="edu-Info-container" v-if="trainList&&trainList.length>0">
                参与培训数：{{trainInfo.amount}}&nbsp;&nbsp;&nbsp;培训总学时：{{trainInfo.periodCount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in trainList"
                  :key="index">
                    <div class="time-title">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-top">
                            <div class="item-time"><el-icon :size="13" class="time-icon"><Clock /></el-icon>提交时间：{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-tag" v-if="t.type===0">直播培训</div>
                            <div class="item-tag" v-if="t.type===1">录播培训</div>
                            <div class="item-tag" v-if="t.type===2">现场培训</div>
                        </div>
                        <div class="item-title">{{t.title}}</div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="trainList&&trainList.length===0">
                <data-empty title="暂无数据" />
            </div>
        </el-scrollbar>
        <!-- 教学教研-->
        <el-scrollbar class="second-container" v-if="activeItem==='3'" >
            <div class="edu-Info-container" v-if="studyList&&studyList.length>0">
                参与总数：{{studyInfo.amount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in studyList"
                  :key="index">
                    <div class="time-title">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-top">
                            <div class="item-time"><el-icon :size="13" class="time-icon"><Clock /></el-icon>提交时间：{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-tag" v-if="t.type===0">个人备课</div>
                            <div class="item-tag" v-if="t.type===1">协同备课</div>
                            <div class="item-tag" v-if="t.type===2">听评课</div>
                        </div>
                        <div class="item-title">{{t.title}}</div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="studyList&&studyList.length===0">
                <home-data-empty title="暂无数据" />
            </div>
        </el-scrollbar>
        <!-- 教科研-->
        <el-scrollbar class="second-container" v-if="activeItem==='4'" >
            <div class="edu-Info-container" v-if="eduList&&eduList.length>0">
                参与总数：{{eduInfo.amount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in eduList"
                  :key="index">
                    <div class="time-title">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-top">
                            <div class="item-time"><el-icon :size="13" class="time-icon"><Clock /></el-icon>提交时间：{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-tag" v-if="t.type===0">课题引领</div>
                            <div class="item-tag" v-if="t.type===1">教研赛事</div>
                            <div class="item-tag" v-if="t.type===2">专题活动</div>
                        </div>
                        <div class="item-title">{{t.title}}</div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="eduList&&eduList.length===0">
                <home-data-empty title="暂无数据" />
            </div>
        </el-scrollbar>

        <el-dialog v-model="isShowDetail" title="成长明细相关数据" width="50%" @close="isShowDetail = !isShowDetail">
            <div class="bre9e">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :data="businessList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  align="center" label="名称" prop="title">
                    </el-table-column>
                    <el-table-column  align="center" label="级别" prop="levelName">
                    </el-table-column>
                    <el-table-column  align="center" width="100" label="范围" prop="natureName">
                    </el-table-column>
                    <el-table-column  align="center" width="100" label="角色" prop="roleName">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import { developDetail,developTrain ,developStudy,developEdu} from "@/api/admin/userCenter"
import homeDataEmpty from "@/components/homeDataEmpty.vue";

export default {
    name: "developCenter",
    components: {homeDataEmpty},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
    },
    data() {
        return {
            timestampToTime,
            isShowDetail:false,
            token: this.$storage.get("token"),
            activeItem:this.itemNum,
            detailList:[],
            businessList:[],
            trainInfo:{},
            trainList:[],
            studyInfo:{},
            studyList:[],
            eduInfo:{},
            eduList:[],

        };
    },
    created() {
        // 成长明细
        this.getDevelopDetail();
        // 师资培训
        this.getDevelopTrain();
        // 教学教研
        this.getDevelopStudy();
        // 教科研
        this.getDevelopEdu();
    },
    activated() {},
    watch: {},
    methods: {
        getDevelopDetail(){
            developDetail().then(res => {
                if (res.data.code===1){
                    this.detailList = res.data.data;
                }
            })
        },
        getDevelopTrain(){
            developTrain().then(res => {
                if (res.data.code===1){
                    this.trainInfo = res.data.data;
                    this.trainList = this.trainInfo.list;
                }
            })
        },
        getDevelopEdu(){
            developEdu().then(res => {
                if (res.data.code===1){
                    this.eduInfo = res.data.data;
                    this.eduList = this.eduInfo.list;
                }
            })
        },
        getDevelopStudy(){
            developStudy().then(res => {
                if (res.data.code===1){
                    this.studyInfo = res.data.data;
                    this.studyList = this.studyInfo.list;
                }
            })
        },
        viewDetail(row){
            this.businessList = row.list;
            this.isShowDetail = true;
        }
    }
};
</script>
<style scoped>
.top-container{
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto!important;
}
.second-container{
    width: 100%;
    height: calc(100vh - 182px);
    box-sizing: border-box;
}
/*成长明细*/
.detail-card{
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    box-sizing: border-box;
}
.amount-text{
    color: #29a8f0;
    font-weight: bold;
}
/*统计信息*/
.edu-Info-container{
    width: fit-content;
    height: 34px;
    line-height: 34px;
    margin-bottom: 12px;
    padding: 0 16px;
    box-sizing: border-box;
    font-size: 14px;
    color: #ff7f2e;
    background: #fff;
    border-radius: 17px;
    font-weight: bold;
}
/*时间线*/
.time-title{
    font-size: 18px;
    color: #1f4e79;
    font-weight: bold;
    margin-bottom: 14px;
}
/deep/ .el-timeline{
    padding-left: 4px;
}
/deep/ .el-timeline-item__node{
    background-color: #ff7f2e;
    border: 2px solid #fff;
    width: 10px;
    height: 10px;
}
/deep/ .el-timeline-item__tail{
    border-left: 2px solid #9ec2e8;
}
/deep/ .el-timeline-item__wrapper{
    padding-left: 20px;
}
.edu-item-container{
    width: 50%;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #eef2f7;
    border-radius: 12px;
    padding: 14px 16px;
    box-sizing: border-box;
    transition: box-shadow .2s;
}
.edu-item-container:hover{
    box-shadow: 0 2px 12px rgba(13, 85, 164, .12);
}
.item-top{
    display: flex;
    align-items: center;
}
.item-time{
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #999;
}
.time-icon{
    color: #29a8f0;
}
.item-tag{
    margin-left: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 10px;
    font-size: 12px;
    background-color: #29a8f0;
    color: #fff;
    text-align: center;
    border-radius: 4px;
}
.item-title{
    margin-top: 8px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
}
</style>
